var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_49880)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6158 15.8485C13.6158 16.8194 14.4028 17.6063 15.3736 17.6063C16.3444 17.6063 17.1314 16.8193 17.1314 15.8485C17.1314 14.8777 16.3445 14.0907 15.3736 14.0907C14.4028 14.0907 13.6158 14.8777 13.6158 15.8485ZM15.3736 16.4345C15.05 16.4345 14.7877 16.1721 14.7877 15.8485C14.7877 15.5249 15.05 15.2626 15.3736 15.2626C15.6972 15.2626 15.9596 15.5249 15.9596 15.8485C15.9596 16.1721 15.6972 16.4345 15.3736 16.4345Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8281 15.2626H16.5455V16.4345H20V8.87816H18.1416L16.5758 4.56445H11.3332V5.73633H15.7545L17.3203 10.05H18.8281V15.2626Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.20176 15.8485C4.20176 16.8193 4.98874 17.6063 5.95957 17.6063C6.93035 17.6063 7.71738 16.8194 7.71738 15.8485C7.71738 14.8777 6.93036 14.0907 5.95957 14.0907C4.98873 14.0907 4.20176 14.8777 4.20176 15.8485ZM5.95957 16.4345C5.63595 16.4345 5.37363 16.1721 5.37363 15.8485C5.37363 15.5249 5.63596 15.2626 5.95957 15.2626C6.28315 15.2626 6.54551 15.5249 6.54551 15.8485C6.54551 16.1721 6.28317 16.4345 5.95957 16.4345Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.414 11.2001H17.691V12.372H19.414V11.2001Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.091 10.05H17.7309V8.87817H14.2629V5.15039H13.091V10.05Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.4345H4.78769V15.2626H1.17187V4.56445H10.7473V15.2626H7.13144V16.4345H11.9191V3.39258H0V16.4345Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.02988 12.0666H8.88926V10.6901C8.88926 9.07206 7.57759 7.76039 5.95957 7.76039C4.34155 7.76039 3.02988 9.07206 3.02988 10.6901V12.0666ZM4.20176 10.8948V10.6901C4.20176 9.71927 4.98876 8.93227 5.95957 8.93227C6.93038 8.93227 7.71738 9.71927 7.71738 10.6901V10.8948H4.20176Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5494 10.8948H2.36971V12.0666H9.5494V10.8948Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37363 7.21273V8.34632H6.54551V7.21273H5.37363Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2018 15.2626H11.3332V16.4345H14.2018V15.2626Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_49880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.8815170b2eb8ed1627fb9bed13ca0902.svg";
export { ForwardRef as ReactComponent };